export enum DealCampaignStepEnum {
  Create = "create",
  Summary = "summary",
}
